define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityWpDocTypeDomain = void 0;
    class FacilityWpDocTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FacilityWpDocTypeDomain.Photo, value: "Photo" },
                    { key: FacilityWpDocTypeDomain.Form2, value: "Form 2" },
                    { key: FacilityWpDocTypeDomain.Form3, value: "Form 3" },
                    { key: FacilityWpDocTypeDomain.Other, value: "Other" },
                    { key: FacilityWpDocTypeDomain.Invoice, value: "Invoice" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FacilityWpDocTypeDomain.Photo] = 0;
                this.KeyIndex[FacilityWpDocTypeDomain.Form2] = 1;
                this.KeyIndex[FacilityWpDocTypeDomain.Form3] = 2;
                this.KeyIndex[FacilityWpDocTypeDomain.Other] = 3;
                this.KeyIndex[FacilityWpDocTypeDomain.Invoice] = 4;
                this.ValueIndex = {};
                this.ValueIndex["Photo"] = 0;
                this.ValueIndex["Form 2"] = 1;
                this.ValueIndex["Form 3"] = 2;
                this.ValueIndex["Other"] = 3;
                this.ValueIndex["Invoice"] = 4;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FacilityWpDocTypeDomain = FacilityWpDocTypeDomain;
    Object.defineProperty(FacilityWpDocTypeDomain, "Photo", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FacilityWpDocTypeDomain, "Form2", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FacilityWpDocTypeDomain, "Form3", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(FacilityWpDocTypeDomain, "Other", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(FacilityWpDocTypeDomain, "Invoice", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(FacilityWpDocTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
